import React from 'react';

class ListViewHeader extends React.Component {
  render() {
    return (
      <thead>
        <tr>
          <th>Lead</th>
          <th>Client</th>
          <th>Opportunity</th>
          <th>Project</th>
          <th>Survey</th>
          <th>TP Project</th>
          <th>TP Survey</th>
          <th>Start – End</th>
          <th className='num'>Spent hours</th>
          <th>Task</th>
          <th>Comment</th>
          <th className='ctr'>Outsourced?</th>
          <th>Billed Office</th>
        </tr>
      </thead>
    );
  }
}

export default ListViewHeader;
